export default __webpack_public_path__ + "static/media/p.d14cf730.png";